<template>
  <div>
    <div class="p-field p-col-12 p-md-4">
      <label for="monthSelect">Select Month:</label>
      <Dropdown 
        id="monthSelect" 
        v-model="selectedMonth" 
        :options="nepaliMonths" 
        optionLabel="name" 
        placeholder="Select Month" 
        @change="handleMonthChange" 
      />
    </div>

    <div class="p-fluid p-grid">
      <!-- Sales Charts -->
      <div class="p-col-12 p-md-6">
        <div class="chart-container">
          <canvas id="weekly-sales-bar"></canvas>
        </div>
      </div>
      <div class="p-col-12 p-md-6">
        <div class="chart-container">
          <canvas id="weekly-sales-line"></canvas>
        </div>
      </div>

      <!-- Target Charts -->
      <div class="p-col-12 p-md-6">
        <div class="chart-container">
          <canvas id="weekly-target-bar"></canvas>
        </div>
      </div>
      <div class="p-col-12 p-md-6">
        <div class="chart-container">
          <canvas id="weekly-target-line"></canvas>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Chart from 'chart.js'
import Dropdown from 'primevue/dropdown'

export default {
  name: 'CombinedWeeklyCharts',
  components: { Dropdown },
  data() {
    return {
      selectedMonth: null,
      salesBarChart: null,
      salesLineChart: null,
      targetBarChart: null,
      targetLineChart: null,
      nepaliMonths: [
        { name: 'Baisakh', value: 1 },
        { name: 'Jestha', value: 2 },
        { name: 'Ashadh', value: 3 },
        { name: 'Shrawan', value: 4 },
        { name: 'Bhadra', value: 5 },
        { name: 'Ashwin', value: 6 },
        { name: 'Kartik', value: 7 },
        { name: 'Mangsir', value: 8 },
        { name: 'Poush', value: 9 },
        { name: 'Magh', value: 10 },
        { name: 'Falgun', value: 11 },
        { name: 'Chaitra', value: 12 }
      ]
    }
  },
  mounted() {
    this.createAllCharts()
  },
  methods: {
    async createAllCharts() {
      try {
        this.destroyAllCharts()
        const selectedMonthName = this.selectedMonth ? this.selectedMonth.name : null
        const [salesData, targetData] = await Promise.all([
          this.$store.dispatch('loadWeekSalesBar', { month: selectedMonthName }),
          this.$store.dispatch('loadWeeklyTargetAchievedBar', { month: selectedMonthName })
        ])
        this.createSalesCharts(salesData, selectedMonthName)
        this.createTargetCharts(targetData, selectedMonthName)
      } catch (error) {
        console.error('Error loading chart data:', error)
      }
    },
    createSalesCharts(data, monthName) {
      this.salesBarChart = new Chart(
        document.getElementById('weekly-sales-bar'),
        {
          type: 'bar',
          data: {
            labels: data.labels,
            datasets: data.datasets.map((dataset, index) => ({
              ...dataset,
              backgroundColor: dataset.label.includes('Target') ? '#3F5EBF' : '#42b3f4',
              borderColor: dataset.label.includes('Target') ? '#3F5EBF' : '#42b3f4'
            }))
          },
          options: {
            responsive: true,
            maintainAspectRatio: false,
            title: {
              display: true,
              text: `Weekly Sales - ${monthName || 'Current Month'}`
            },
            scales: { y: { beginAtZero: true } }
          }
        }
      )
      // Sales Line Chart
      this.salesLineChart = new Chart(
        document.getElementById('weekly-sales-line'),
        {
          type: 'line',
          data: {
            ...data,
            datasets: data.datasets.map(dataset => ({
              ...dataset,
              fill: false,
              borderColor: '#36a2eb',
              tension: 0.1
            }))
          },
          options: {
            responsive: true,
            maintainAspectRatio: false,
            title: {
              display: true,
              text: `Sales Trend - ${monthName || 'Current Month'}`
            },
            scales: { y: { beginAtZero: true } }
          }
        }
      )
    },
    createTargetCharts(data, monthName) {
      // Target Bar Chart
      this.targetBarChart = new Chart(
        document.getElementById('weekly-target-bar'),
        {
          type: 'bar',
          data: {
            labels: data.labels,
            datasets: data.datasets.map((dataset, index) => ({
              ...dataset,
              backgroundColor: dataset.label.includes('Target') ? '#3F5EBF' : '#42b3f4',
              borderColor: dataset.label.includes('Target') ? '#3F5EBF' : '#42b3f4'
            }))
          },
          options: {
            responsive: true,
            maintainAspectRatio: false,
            title: {
              display: true,
              text: `Target vs Achieved - ${monthName || 'Current Month'}`
            },
            scales: { y: { beginAtZero: true } }
          }
        }
      )
      // Target Line Chart
      this.targetLineChart = new Chart(
        document.getElementById('weekly-target-line'),
        {
          type: 'line',
          data: {
            labels: data.labels,
            datasets: data.datasets.map(dataset => ({
              ...dataset,
              fill: false,
              tension: 0.1,
              borderColor: dataset.label.includes('Target') ? '#3F5EBF' : '#42b3f4'
            }))
          },
          options: {
            responsive: true,
            maintainAspectRatio: false,
            title: {
              display: true,
              text: `Target Trend - ${monthName || 'Current Month'}`
            },
            scales: { y: { beginAtZero: true } }
          }
        }
      )
    },

    destroyAllCharts() {
      ;[this.salesBarChart, this.salesLineChart, this.targetBarChart, this.targetLineChart]
        .forEach(chart => {
          if (chart) {
            chart.destroy()
            chart = null
          }
        })
    },

    handleMonthChange() {
      this.createAllCharts()
    }
  }
}
</script>

<style scoped>
.chart-container {
  background: white;
  padding: 20px;
  border-radius: 10px;
  box-shadow: 0 0 10px rgba(0,0,0,0.1);
  margin-bottom: 20px;
  min-height: 400px;
}

canvas {
  width: 100% !important;
  height: 400px !important;
}

.p-grid {
  margin-top: 20px;
}
</style>



// WEBPACK FOOTER //
// WeeklySalesReportGraph.vue?e906de1c